import { writable } from 'svelte/store';
import { SNACKBAR_TRANSITION_DURATION as duration } from '../config';
import type { Snack } from '../types';

function createSnacksStore() {
  const { subscribe, update } = writable<Snack[]>([]);

  let counterId = 0;

  function removeSnack(id: number) {
    update((current) => current.filter((item) => item.id !== id));
  }

  return {
    subscribe,
    push: ({ message, type }: Omit<Snack, 'id'>) => {
      update((current) => {
        const id = ++counterId;

        setTimeout(() => removeSnack(id), duration);

        return [...current, { message, id, type }];
      });
    },
    remove: removeSnack,
  };
}
export const snacks = createSnacksStore();
